class AuthManager {
  constructor (defaultService, surrogateService, providerKey, surrogateProvider) {
    this.defaultService = defaultService
    this.surrogateService = surrogateService
    this.providerKey = providerKey
    this.surrogateProvider = surrogateProvider
    this.currentService = this._selectInitialService()
  }

  _selectInitialService () {
    const isSurrogateProvider = localStorage.getItem(this.providerKey) === this.surrogateProvider
    const hasSurrogateSession = typeof document !== 'undefined' && document.cookie
      .split(';')
      .some(cookie => cookie.trim().startsWith('hmSsoSurrogateExp='))
    const isSurrogate = isSurrogateProvider || hasSurrogateSession

    if (hasSurrogateSession && !isSurrogateProvider) {
      localStorage.setItem(this.providerKey, this.surrogateProvider)
    }

    return isSurrogate ? this.surrogateService : this.defaultService
  }

  useSurrogate () {
    this.currentService = this.surrogateService
    localStorage.setItem(this.providerKey, this.surrogateProvider)
  }

  useDefault () {
    this.currentService = this.defaultService
    localStorage.removeItem(this.providerKey)
  }

  getService () {
    return this.currentService
  }
}

export default AuthManager
